import {
	Injectable,
	SecurityContext
} from '@angular/core';
import {
	DomSanitizer
} from '@angular/platform-browser';
import {
	Http
} from '@angular/http';
import {
	Observable
} from 'rxjs/Observable';
import {
	Resolve
} from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

export interface IMessage{
	email?: string,
	phone?: string,
	first_name?: string,
	last_name?: string,
	about_you?: string,
	accounting_bookkeeping?: boolean,
	tax?: boolean,
	payroll_processing?: boolean,
	consulting?: boolean,
	html?:string
}
export interface RMessage{
	email?: string,
	phone?: string,
	your_name?: string,
	their_name?: string,
	message?: string,
	html?: string
}
@Injectable()
export class EmailService{
	private url = './peeps/email.php';
	private referUrl = './peeps/refer.php';
	private style = 
	`
		<style type="text/css" media="screen">
			html{box-sizing:border-box}*,*:before,*:after{box-sizing:inherit}
			html{-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}
			article,aside,details,figcaption,figure,footer,header,main,menu,nav,section,summary{display:block}
			audio,canvas,progress,video{display:inline-block}progress{vertical-align:baseline}
			audio:not([controls]){display:none;height:0}[hidden],template{display:none}
			a{background-color:transparent;-webkit-text-decoration-skip:objects}
			a:active,a:hover{outline-width:0}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}
			dfn{font-style:italic}mark{background:#ff0;color:#000}
			small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}
			sub{bottom:-0.25em}sup{top:-0.5em}figure{margin:1em 40px}img{border-style:none}svg:not(:root){overflow:hidden}
			code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}hr{box-sizing:content-box;height:0;overflow:visible}
			button,input,select,textarea{font:inherit;margin:0}optgroup{font-weight:bold}
			button,input{overflow:visible}button,select{text-transform:none}
			button,html [type=button],[type=reset],[type=submit]{-webkit-appearance:button}
			button::-moz-focus-inner, [type=button]::-moz-focus-inner, [type=reset]::-moz-focus-inner, [type=submit]::-moz-focus-inner{border-style:none;padding:0}
			button:-moz-focusring, [type=button]:-moz-focusring, [type=reset]:-moz-focusring, [type=submit]:-moz-focusring{outline:1px dotted ButtonText}
			fieldset{border:1px solid #c0c0c0;margin:0 2px;padding:.35em .625em .75em}
			legend{color:inherit;display:table;max-width:100%;padding:0;white-space:normal}textarea{overflow:auto}
			[type=checkbox],[type=radio]{padding:0}
			[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}
			[type=search]{-webkit-appearance:textfield;outline-offset:-2px}
			[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}
			::-webkit-input-placeholder{color:inherit;opacity:0.54}
			::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}
			/* End extract */
			html,body{font-family:Verdana,sans-serif;font-size:15px;line-height:1.5}html{overflow-x:hidden}
			h1{font-size:36px}h2{font-size:30px}h3{font-size:24px}h4{font-size:20px}h5{font-size:18px}h6{font-size:16px}.w3-serif{font-family:serif}
			h1,h2,h3,h4,h5,h6{font-family:"Segoe UI",Arial,sans-serif;font-weight:400;margin:10px 0}.w3-wide{letter-spacing:4px}
			hr{border:0;border-top:1px solid #eee;margin:20px 0}
		</style>
	`;
	constructor(private http: Http, private sanitizer: DomSanitizer){
		this.sanitizer = sanitizer;
	}
	private sanitizeMsg(message: IMessage){
		message.email = this.sanitizer.sanitize(SecurityContext.HTML, message.email);
		message.first_name = this.sanitizer.sanitize(SecurityContext.HTML, message.first_name);
		message.last_name = this.sanitizer.sanitize(SecurityContext.HTML, message.last_name);
		message.about_you = this.sanitizer.sanitize(SecurityContext.HTML, message.about_you);
		message.phone = this.sanitizer.sanitize(SecurityContext.HTML, message.phone);			

		if (typeof message.accounting_bookkeeping !== "boolean"){
			message.accounting_bookkeeping = false;
		}
		if (typeof message.consulting !== "boolean"){
			message.consulting = false;
		}
		if (typeof message.payroll_processing !== "boolean"){
			message.payroll_processing = false;
		}
		if (typeof message.tax !== "boolean"){
			message.tax = false;
		}
		return message;
	}
	private sanitizeRMsg(message: RMessage){
		message.message = this.sanitizer.sanitize(SecurityContext.HTML, message.message);
		message.their_name = this.sanitizer.sanitize(SecurityContext.HTML, message.their_name);
		message.your_name = this.sanitizer.sanitize(SecurityContext.HTML, message.your_name);
		message.phone = this.sanitizer.sanitize(SecurityContext.HTML, message.phone);
		return message;
	}
	private buildHtmlEmail(message: IMessage){
		var interests = '';
		var phone = '';
		message = this.sanitizeMsg(message);
		if(message.phone != ''){
			phone = `<label><strong>Phone Number:</strong>`+message.phone+`</label><br><br>`;
		}
		if(message.accounting_bookkeeping||message.consulting||message.payroll_processing||message.tax){
			interests = `<div><div><label><strong>Their interests:</strong></label></div><ul>`;
			if(message.accounting_bookkeeping) interests+=`<li>Accounting &amp; Bookkeeping</li>`;
			if(message.tax)interests+=`<li>Tax Planning &amp; Preperation</li>`;
			if(message.payroll_processing)interests+=`<li>Payroll Processing</li>`;
			if(message.consulting)interests+=`<li>Consulting</li>`;
			interests+=`</ul></div>`;
		}
		var html = `<!DOCTYPE html>
			<html>
				`+this.style+`
				<head>
					<meta charset="utf-8">
					<meta http-equiv="X-UA-Compatible" content="IE=edge">
					<meta name="viewport" content="width=device-width, initial-scale=1">
				</head>
				<body style="width: 100%; height: 100%;">
					<header>
						<div style="background-color: #303F9F;width: 100%; height: auto;box-shadow: 0px 4px 4px #00000044">
							<h2 style="color: gold;text-align: center;margin-top: auto; margin-bottom: auto;padding:8px;">Garth V Rogers, CPA PLLC</h2>	
						</div>
					</header>
					<div style="margin: 16px!important;background-color: #fff; border-radius: 8px;box-shadow: 0px 0px 8px #00000044">
						<div style="margin: 16px;padding: 16px;">
							<h3 style="text-align: center;">You've been contacted by `+message.first_name + ` ` + message.last_name +`!</h3>
							<hr>
							<div>
								<label><strong>Email:</strong> `+message.email+`</label>
								<br>
								<br>
								`+phone+`
								<label><strong>About Them:</strong></label>
								<br>
								<p>
									`+message.about_you+`
								</p>
								` + interests + `
							</div>
						</div>
					</div>
				</body>
			</html>`;
			return html;
	}
	private buildHtmlRefer(message: RMessage){
		var phone = '';
		var thoughts = '';
		message = this.sanitizeRMsg(message);
		if(message.phone != '' && message.phone != null){
			phone = `<br><br><label><strong>Phone Number:</strong>`+message.phone+`</label>`;
		}
		if(message.message != '' && message.message != null){
			thoughts = `<br><br><label><strong>Their Thoughts:</strong></label><br><p>`+message.message+`</p>`;
		}
		var html = `<!DOCTYPE html>
			<html>
				`+this.style+`
				<head>
					<meta charset="utf-8">
					<meta http-equiv="X-UA-Compatible" content="IE=edge">
					<meta name="viewport" content="width=device-width, initial-scale=1">
				</head>
				<body style="width: 100%; height: 100%;">
					<header>
						<div style="background-color: #303F9F;width: 100%; height: auto;box-shadow: 0px 4px 4px #00000044">
							<h2 style="color: gold;text-align: center;margin-top: auto; margin-bottom: auto;padding:8px;">Garth V Rogers, CPA PLLC</h2>	
						</div>
					</header>
					<div style="margin: 16px!important;background-color: #fff; border-radius: 8px;box-shadow: 0px 0px 8px #00000044">
						<div style="margin: 16px;padding: 16px;">
							<h3 style="text-align: center;">`+message.your_name+` referred you to `+message.their_name+`!</h3>
							<hr>
							<div>
								<label><strong>Email:</strong>`+message.email+`</label>
								`+phone+`
								`+thoughts+`
							</div>
						</div>
					</div>
				</body>
			</html>`;
			return html;
	}
	sendEmail(message: IMessage): Observable<IMessage> | any {
		message.html = this.buildHtmlEmail(message);
		// console.log(message.html);
		return this.http.post(this.url, message)
		.map(response =>{
			// console.log('Sending email was successful', response);
			return response;
		})
	}
	sendRefer(message: RMessage): Observable<RMessage> | any {
		message.html = this.buildHtmlRefer(message);
		// console.log(message.html);
		return this.http.post(this.referUrl, message)
		.map(response =>{
			// console.log('Sending email was successful', response);
			return response;
		})
	}
}


// WEBPACK FOOTER //
// D:/Projects/GitHub/gvrogers/src/app/services/email.component.ts